import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import cabeceraCud from '../../assets/cabeceraCat.png';
import { useSelector } from 'react-redux';
import { fechaHoraActualBoliviaSoloVista } from '../../util/valueCalculator';
import { addFooter, addHeader, addTitles } from './TemplatePrintModals';

const CustomPrintModalBalanceGeneral = ({
  show,
  handleClose,
  title1,
  title2,
  content,
  copia,
}) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const { nombre } = useSelector((state) => state.sesion);

  useEffect(() => {
    if (show && content) {
      generatePdf();
    }
  }, [show, content]);

  const generatePdf = () => {
    const doc = new jsPDF('p', 'pt', 'letter');
    const marginLeftRight = 55;
    const marginTop = 35;
    const marginBottom = 75;
    const headerHeight = 60;
    const pageHeight = doc.internal.pageSize.getHeight();
    let currentY;
    const addWatermark = (doc) => {
      const pageHeight = doc.internal.pageSize.getHeight();
      const pageWidth = doc.internal.pageSize.getWidth();

      doc.setFontSize(72);
      doc.setTextColor(240, 240, 240);
      doc.setFont('helvetica', 'bold');
      doc.text('COPIA', pageWidth / 2, pageHeight / 2, {
        angle: 45,
        align: 'center',
      });
    };
    const titles = {validTitle1:title1||"", validTitle2:title2||""};
    const margins = {marginLeftRight, marginTop, marginBottom};

    const addHeaderLocal = (doc, isNewPage = false) => {
      if (isNewPage) {
        doc.addPage();
      }
      addHeader({doc, showPageNumber:false, headerHeight, marginLeftRight,marginTop});
      currentY = addTitles({doc, titles, margins, headerHeight});
    };


    const checkPageBreak = (doc, currentY, neededSpace = 50) => {
      if (currentY + neededSpace > pageHeight - marginBottom) {
         addFooter({doc,marginLeftRight, marginBottom,nombre});
        addHeaderLocal(doc, true);
        return marginTop + headerHeight + 80;
      }
      return currentY;
    };

    const generateOneColumn = (doc) => {
      const pageWidth = doc.internal.pageSize.getWidth();
      const marginLeft = 50;
      currentY = marginTop + headerHeight + 80;

      const activos = content?.activos || [];
      const pasivosYpatrimonio = content?.pasivosYpatrimonio || [];

      const printCuentasNivel = (doc, cuentas, x, y) => {
        cuentas.forEach((cuenta) => {
          if (!cuenta || !cuenta.codigo_cuenta) return;

          // Verificar si necesitamos nueva página
          y = checkPageBreak(doc, y, 15);

          const nivel = Math.floor(cuenta.codigo_cuenta.length / 2);
          const nombre = cuenta.nombre || "Sin Nombre";
          const valor = typeof cuenta.valor === "number" ? cuenta.valor : 0;
          const valorX = pageWidth - 70 - nivel * 40;

          doc.setFont("times", "normal");
          doc.setFontSize(10);
          doc.text(nombre, x, y);
          doc.text(
            `${valor.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
            valorX,
            y,
            { align: "right" }
          );

          y += 15;
        });
        return y;
      };

      // Sección de Activos
      doc.setFontSize(12);
      doc.setFont("times", "bold");
      doc.text("ACTIVO", marginLeft, currentY);
      currentY += 20;

      currentY = printCuentasNivel(doc, activos, marginLeft, currentY);

      // Verificar espacio para el total
      currentY = checkPageBreak(doc, currentY, 30);

      doc.setFont("times", "bold");
      doc.setFontSize(10);
      doc.text(
        `TOTAL ACTIVO: ${
          typeof content?.totalActivos === "number"
            ? content.totalActivos.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "0.00"
        }`,
        pageWidth - 70,
        currentY,
        { align: "right" }
      );
      currentY += 30;

      // Sección de Pasivo y Patrimonio
      currentY = checkPageBreak(doc, currentY, 40); // Más espacio para el título

      doc.setFontSize(12);
      doc.setFont("times", "bold");
      doc.text("PASIVO Y PATRIMONIO", marginLeft, currentY);
      currentY += 20;

      currentY = printCuentasNivel(doc, pasivosYpatrimonio, marginLeft, currentY);

      // Verificar espacio para el total
      currentY = checkPageBreak(doc, currentY, 30);

      doc.setFont("times", "bold");
      doc.setFontSize(10);
      doc.text(
        `TOTAL PASIVO Y PATRIMONIO: ${
          typeof content?.totalPasivosPatrimonio === "number"
            ? content.totalPasivosPatrimonio.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "0.00"
        }`,
        pageWidth - 70,
        currentY,
        { align: "right" }
      );
    };

    // Generar PDF
    addHeaderLocal(doc);
    if (copia) addWatermark(doc);
    generateOneColumn(doc);
    addFooter({doc,marginLeftRight, marginBottom,nombre});

    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    setPdfUrl(pdfUrl);
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{title1}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {pdfUrl && (
          <iframe
            src={pdfUrl}
            width="100%"
            height="500px"
            title="Vista previa del Balance General"
          ></iframe>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomPrintModalBalanceGeneral;